export enum ConversationPageTab {
    CHAT = 'chat',
    TICKET = 'ticket',
    CLIENT = 'client',
    TEAM_CHAT = 'team-chat'
}